import { useCallback } from 'react';

// eslint-disable-next-line no-restricted-imports
import {
  OnboardingLegalClientDocument,
  OnboardingLegalClientParticipantsDocument,
  useLegalClientSaveLegalHeadFirstHeadEmailMutation,
} from 'api/generated/graphql';
import { useError } from 'api/helpers';

export const useLegalClientSaveLegalHeadFirstHeadEmail = () => {
  const [handle, { data, loading, error: apolloError }] =
    useLegalClientSaveLegalHeadFirstHeadEmailMutation({
      refetchQueries: [
        OnboardingLegalClientDocument,
        OnboardingLegalClientParticipantsDocument,
      ],
      awaitRefetchQueries: true,
    });

  const error = useError(apolloError);

  const saveFirstHeadEmail = useCallback(
    async (
      legalId: string,
      legalHeadId: string,
      firstHeadId: string,
      email: string
    ) => {
      const res = await handle({
        variables: { id: legalId, firstHeadId, legalHeadId, input: { email } },
      });
      return res.data?.legalClientSaveLegalHeadFirstHeadEmail;
    },
    [handle]
  );

  return {
    data,
    loading,
    error,
    saveFirstHeadEmail,
  };
};
